var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var FooterWrapper = styled.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  bottom: 0;\n  z-index: 999;\n  width: 100%;\n  padding: 10px 0;\n  font-size: 11px;\n  background: #333;\n  color: rgba(255, 255, 255, 0.7);\n  text-align: center;\n\n  .links {\n    margin-top: 4px;\n    a {\n      text-decoration: none;\n      color: #999;\n    }\n  }\n"], ["\n  bottom: 0;\n  z-index: 999;\n  width: 100%;\n  padding: 10px 0;\n  font-size: 11px;\n  background: #333;\n  color: rgba(255, 255, 255, 0.7);\n  text-align: center;\n\n  .links {\n    margin-top: 4px;\n    a {\n      text-decoration: none;\n      color: #999;\n    }\n  }\n"])));
var FooterContainer = function (_a) {
    var isTaiwaneseRoaster = _a.isTaiwaneseRoaster, children = _a.children;
    return (React.createElement(FooterWrapper, null,
        isTaiwaneseRoaster ? (React.createElement("div", null,
            "2020-2023 \u00A9 \u9435\u6BD4\u5361\u80A1\u4EFD\u6709\u9650\u516C\u53F8 TYPICA TW,Inc",
            React.createElement("br", null),
            "\u7D71\u4E00\u7DE8\u865F:90550645")) : (React.createElement("div", null, "2020-2023 \u00A9 TYPICA")),
        children));
};
export default FooterContainer;
var templateObject_1;
